interface RadioButtonProps {
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  testId?: string;
  disabled?: boolean;
}

export function RadioButton({
  label,
  value,
  checked,
  onChange,
  testId,
  disabled = false,
}: RadioButtonProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(value)}
      data-testid={testId}
      className={`w-full flex items-center gap-4 px-4 py-4 rounded-[6px] border transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2D55FB] focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none ${
        checked
          ? "border-black bg-white"
          : "border-[#E0E0E0] bg-white hover:border-gray-300"
      }`}
    >
      <div className="relative w-4 h-4 flex items-center justify-center flex-shrink-0" aria-hidden="true">
        <div
          className={`absolute w-4 h-4 rounded-full ${
            checked ? "bg-black" : "bg-[#E0E0E0]"
          }`}
        />
        <div className="absolute w-3.5 h-3.5 rounded-full bg-white" />
        <div
          className={`absolute w-3 h-3 rounded-full ${
            checked ? "bg-black" : "bg-[#E0E0E0]"
          }`}
          style={{ width: "12px", height: "12px" }}
        />
      </div>
      <span
        className="text-left text-base leading-[24px] text-black"
        style={{ fontFamily: "TT Commons Pro" }}
      >
        {label}
      </span>
    </button>
  );
}
